/**
 * Weekday constants for RA2 (月火水木金土日).
 * value 1–6 = Mon–Sat, 0 = Sun (matches dayjs .day()).
 */
export const WEEKDAY_LABELS: { value: number; label: string }[] = [
  { value: 1, label: '月' },
  { value: 2, label: '火' },
  { value: 3, label: '水' },
  { value: 4, label: '木' },
  { value: 5, label: '金' },
  { value: 6, label: '土' },
  { value: 0, label: '日' },
];

/** Index = JS Date.getDay() (0=Sun, 1=Mon, ..., 6=Sat). */
export const WEEKDAY_LABELS_BY_INDEX: string[] = ['日', '月', '火', '水', '木', '金', '土'];

/** Mon–Sun order for week calendar headers. */
export const WEEKDAY_LABELS_MON_FIRST: string[] = ['月', '火', '水', '木', '金', '土', '日'];

/** For schedule forms (is_am_monday, is_pm_tuesday, etc.). */
export const WEEKDAY_LABELS_WITH_KEY = [
  { key: 'monday', label: '月' },
  { key: 'tuesday', label: '火' },
  { key: 'wednesday', label: '水' },
  { key: 'thursday', label: '木' },
  { key: 'friday', label: '金' },
  { key: 'saturday', label: '土' },
  { key: 'sunday', label: '日' },
] as const;
